/** Money stays pending until authenticated provider evidence has been matched. */
export interface PaymentReview {
  paymentId: string;
  saleId: string;
  branchId: string;
  amountSatang: number;
  reference: string;
  reportedAt: string | null;
  reportedBy: string | null;
  paymentStatus: string;
  reviewStatus: 'waiting' | 'confirmed' | 'attention' | 'released';
  voidStatus: 'none' | 'pending' | 'unknown' | 'succeeded' | 'rejected';
  voidSubmittedAt?: string | null;
  releasedAt?: string | null;
  releaseReason?: string | null;
  voidReason: string | null;
  voidedAt: string | null;
  deviceAppliedAt: string | null;
  lastResult: string | null;
}

export interface PaymentSlipEvidence {
  evidenceId: string;
  uploadedAt: string;
  uploadedBy: string;
  result: string;
  transRef: string;
  sendingBank: string;
}

export interface PaymentReviewDetail {
  payment: PaymentReview;
  evidence: PaymentSlipEvidence[];
}

export type GatewayPaymentReviewState = Pick<
  PaymentReview,
  'reportedAt' | 'voidStatus' | 'voidedAt'
>;

/** Parse the mini-QR's nested TLV, never OCR a printed reference number. */
export function parseScbSlipQr(value: string): {
  transRef: string;
  sendingBank: string;
} | null {
  if (value.length > 1024 || !value) return null;
  const read = (text: string): Map<string, string> | null => {
    const fields = new Map<string, string>();
    for (let offset = 0; offset < text.length;) {
      const header = text.slice(offset, offset + 4);
      if (!/^\d{4}$/.test(header)) return null;
      const tag = header.slice(0, 2);
      const length = Number(header.slice(2));
      if (fields.has(tag) || offset + 4 + length > text.length) return null;
      fields.set(tag, text.slice(offset + 4, offset + 4 + length));
      offset += 4 + length;
    }
    return fields;
  };
  const outer = read(value);
  const inner = outer?.get('00') ? read(outer.get('00')!) : null;
  const sendingBank = inner?.get('01') ?? '';
  const transRef = inner?.get('02') ?? '';
  return /^\d{3}$/.test(sendingBank) && /^[A-Za-z0-9]{1,64}$/.test(transRef)
    ? { sendingBank, transRef }
    : null;
}

export interface PaymentReviewPage {
  items: PaymentReview[];
  openCount: number;
  nextOffset: number | null;
}
